import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import style from '../ProductPrice.module.scss.js';

const PricePrevious = ({ ariaLabel, text, ...otherProps }) => text ? (jsxs(Fragment, { children: [ariaLabel && (jsx("span", { className: "pp-visually-hidden", children: `${ariaLabel} ${text} ` })), jsx("del", { className: style['z-product-price__previous'], "aria-hidden": ariaLabel ? true : undefined, ...otherProps, children: text }), ' '] })) : null;
PricePrevious.displayName = 'PricePrevious';

export { PricePrevious };
//# sourceMappingURL=PricePrevious.js.map
